<template>
    <b-container fluid class="mt--7 pb-4">
        <b-card title="Vehicle">
            <form @submit.prevent="update()">
                <b-form-group
                    id="name-group"
                    label="Name"
                    label-for="input-name"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="driver-group"
                    label="Driver"
                    label-for="input-driver"
                >
                    <b-form-select
                        id="input-driver"
                        name="input-driver"
                        v-model="model.driver"
                        value-field="id"
                        text-field="name"
                        :options="
                            drivers.map(x => {
                                x.name = `${x.first_name} ${x.last_name}`
                                return x
                            })
                        "
                    >
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    id="registration-group"
                    label="Registration"
                    label-for="input-registration"
                >
                    <b-form-input
                        type="text"
                        id="input-registration"
                        v-model="model.registration"
                        required
                        placeholder="Enter Registration"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="model-group"
                    label="Model"
                    label-for="input-model"
                >
                    <b-form-input
                        type="text"
                        id="input-model"
                        v-model="model.model"
                        required
                        placeholder="Enter Model"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                >
                    <b-form-textarea
                        id="input-description"
                        v-model="model.description"
                        placeholder="Enter Description"
                        rows="3"
                    ></b-form-textarea>
                </b-form-group>

                <b-form-group
                    id="color-group"
                    label="Color"
                    label-for="input-color"
                >
                    <b-form-input
                        type="color"
                        id="input-color"
                        v-model="model.color"
                        placeholder="Enter Color"
                    ></b-form-input>
                </b-form-group>

                <b-row>
                    <b-col>
                        <b-button
                            variant="primary"
                            @click="update()"
                            class="float-right"
                            :disabled="updating ? true : false"
                            >{{
                                updating ? 'Saving Changes...' : 'Save Changes'
                            }}</b-button
                        >
                        <b-button
                            @click="deleteVehicle()"
                            class="float-right"
                            variant="warning"
                            v-show="user_permissions.includes('delete.fleet')"
                        >
                            Delete
                        </b-button>
                    </b-col>
                </b-row>
            </form>
        </b-card>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'

export default {
    name: 'view-vehicle',
    mixins: [popupMixins, utilityMixins],
    data() {
        return {
            model: {
                id: 0,
                name: '',
                location: '',
                lat: '',
                lon: '',
                driver: 0,
                warehouse: 0,
            },

            updating: false,
        }
    },
    computed: {
        vehicle() {
            const vehicle = { ...this.$store.state.fleet.vehicle }
            vehicle.driver = vehicle.driver && vehicle.driver.user_id
            console.log('vehcile', vehicle)
            return vehicle
        },
        drivers() {
            return this.$store.state.fleet.drivers
        },
        warehouses() {
            return this.$store.state.fleet.warehouses
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {
        vehicle: function(val) {
            this.model = val
        },
    },
    methods: {
        update() {
            this.updating = true
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store
                        .dispatch('fleet/update', this.model)
                        .then(() => {
                            this.doToast(
                                'Vehicle Updated',
                                'Vehicle Updated',
                                'success'
                            )
                        })
                        .catch(error => {
                            this.doToast(
                                'Error!',
                                error.response.data.error.message,
                                'danger'
                            )
                        })
                        .finally(() => {
                            this.updating = false
                        })
                } else {
                    this.updating = false
                }
            })
        },

        deleteVehicle() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/fleet',
                deleteRoute: 'fleet/delete',
            }
            const notificationFields = {
                type: 'Vehicle',
                errorMsg: 'Unable to delete vehicle!',
            }

            this.deleteItem(notificationFields, model, routes)
        },
    },
    mounted() {
        this.$store.dispatch('fleet/fetchById', this.$route.params.id)
        this.$store.dispatch('fleet/fetchDrivers')
        this.$store.dispatch('fleet/fetchWarehouses')
    },
}
</script>
<style></style>
